import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProtectedImageResponse } from 'src/app/modal/catalogo/protected-image-response';

@Injectable({
  providedIn: 'root'
})
export class ProtectedImageService {

  constructor(private http: HttpClient) { }

  getProtectedThumbnail(imageId: string): Observable<ProtectedImageResponse> {
    return this.http.get<ProtectedImageResponse>(`${environment.urlBase}api/images/protected-thumbnail/${imageId}`);
  }

  getProtectedPreview(imageId: string): Observable<ProtectedImageResponse> {
    return this.http.get<ProtectedImageResponse>(`${environment.urlBase}api/images/protected-preview/${imageId}`);
  }
}